import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker, useLoadScript, useJsApiLoader } from '@react-google-maps/api';

interface LatLng {
  lat: number;
  lng: number;
}
interface Map2Props {
  center: LatLng;
  onMarkerMove: (lat: number, lng: number) => void;
}

 
const Map2 = ({ center, onMarkerMove }: Map2Props) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [selectedPosition, setSelectedPosition] = useState<LatLng>(center);

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    // googleMapsApiKey: 'AIzaSyCG3Kt_jO8o7x67EsdV9RuTJP5IxSEwmeo'
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY
  });

  const handleMarkerDragEnd = (event: google.maps.MapMouseEvent) => {
    const latLng = event.latLng;
    if (latLng) {
      const lat = latLng.lat();
      const lng = latLng.lng();
      updatePosition(lat, lng);
    }
  };

 

  const updatePosition = (lat: number, lng: number) => {
    const newPosition = { lat, lng };
    setSelectedPosition(newPosition);
    onMarkerMove(lat, lng);
  };

  const onLoad = useCallback(
    (mapInstance: google.maps.Map) => {
      // const bounds = new google.maps.LatLngBounds(center);
      // mapInstance.fitBounds(bounds);
      setMap(mapInstance);
    },
    [center]
  );

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  useEffect(() => {
    setSelectedPosition(center);
  }, [center]);

  if (!isLoaded) return null;

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      center={selectedPosition}
      zoom={10}
      onLoad={onLoad}
      onUnmount={onUnmount}
      //!~~
      mapTypeId='roadmap'
       options={{
        disableDefaultUI: false // تظهر كل أدوات الخريطة
        // zoomControl: true,
        // mapTypeControl: true,
        // fullscreenControl: false,
        // styles: [], // تقدر تضيف ستايل مخصص
      }}
    >
      <Marker position={selectedPosition} draggable onDragEnd={handleMarkerDragEnd} />
    </GoogleMap>
  );
};

export default Map2;
